module.exports = __webpack_public_path__ + "img/comfort_img@2x.7eef1b08.png";